import { KRUNGTHAI_BANK_CODE } from "const";
import { isRO, isSecurityTypeDBT } from "./product-order-util";

const UNLIMIT_SIGNIFICANT = 888_888_888;

export const isAlreadyRedeem = (unitHolder) => unitHolder?.redeemFlag === "Y";
export const haveNotRedeem = (unitHolder) => unitHolder?.redeemFlag === "N";
export const isKrungthaiBankAccount = (intReceiveBank) => intReceiveBank === KRUNGTHAI_BANK_CODE;

export const isUnLimit = (unitHolder) =>
  unitHolder && (unitHolder.limitFlag === "N" || isRemianUnitSignificantlyUnlimit(unitHolder));

export const isRemianUnitSignificantlyUnlimit = (unitHolder) =>
  unitHolder && +unitHolder.remainUnit > UNLIMIT_SIGNIFICANT;

export const isDBT_RO = (productDetail) => isSecurityTypeDBT(productDetail) && isRO(productDetail);

export const shouldLockedRedeemPaymentAccount = (productDetail, unitHolder) => {
  return isDBT_RO(productDetail) && shouldAutoRedeem(productDetail) && isAlreadyRedeem(unitHolder);
};

export const shouldLockedRedeemReceiveAccount = (productDetail, unitHolder, forceDisabledReceiveAccount) => {
  return (
    isDBT_RO(productDetail) &&
    shouldAutoRedeem(productDetail) &&
    isAlreadyRedeem(unitHolder) &&
    (isKrungthaiBankAccount(unitHolder?.intReceiveBank) || forceDisabledReceiveAccount)
  );
};

export const shouldShowWarningAutoRedeem = (unitHolder) => unitHolder?.redeemFlag === "N";

export const shouldAutoRedeem = (productDetail) => productDetail.sellAutoRedeem === "Y";

export const isAutoRedeemCase = (productDetail, unitHolder) => {
  return isDBT_RO(productDetail) && shouldAutoRedeem(productDetail) && haveNotRedeem(unitHolder);
};

export const shouldDefaultPurchaseUnitWithRemainUnit = (unitHolder) => {
  const isLimit = !isRemianUnitSignificantlyUnlimit(unitHolder);
  return isLimit;
  // return !isUnLimit(unitHolder)
  // return isDBT_RO(productDetail) && !isUnLimit(unitHolder)
};
